export enum TimeEntryEvent {
  NEW_TIME_ENTRY = 'TimeEntryEvent:NEW_TIME_ENTRY'
}
